package songwritersnotebook.app.utils

actual object InterstitialAdManager {
    actual fun initialize(context: Any) {}
    actual fun updatePremiumStatus(isPremium: Boolean) {}
    actual fun showAd(activity: Any, onAdDismissed: () -> Unit) {
        onAdDismissed()
    }
}
